export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-background-50 whitespace-nowrap">妖精漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              妖精漫画网免费漫画资源全覆盖，热门完结连载全部免费看，下拉式阅读体验超爽，追更不等待。韩漫日漫国漫三大品类，奇幻魔幻恋爱题材一网打尽，好看的漫画尽在妖精漫画网大全。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-primary-400 transition-colors">首页</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors">更新快讯</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors">热门连载</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors">人气排行</a></li>
              <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors">常见问答</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">韩漫专区</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">日漫专区</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors">国漫专区</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors">全部索引</a></li>
              <li><a href="#app" className="text-sm text-background-400 hover:text-primary-400 transition-colors">移动阅读</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500 leading-relaxed">
              妖精漫画网与多家优质漫画平台保持友好合作关系，持续为用户提供丰富的免费漫画资源与流畅的在线阅读体验。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors">
                <i className="ri-mail-line text-background-200 text-sm"></i>
              </a>
              <a href="#hero" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 transition-colors">
                <i className="ri-wechat-line text-background-200 text-sm"></i>
              </a>
            </div>
          </div>

        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 妖精漫画网 — 免费漫画大全，好看的韩漫日漫国漫随便看
          </p>
          <p className="text-xs text-background-600">
            本站内容仅供学习交流，请支持正版
          </p>
        </div>
      </div>
    </footer>
  );
}